import angular from 'angular';

export default function clampHtml($window, $parse) {
  'ngInject';

  class Clamper {
    constructor(element, clamp, lineHeight, clampCallbackBound) {
      Object.assign(this, { element, clamp, lineHeight, clampCallbackBound });
    }

    getElementHeight() {
      const computedStyleHeight = $window.getComputedStyle(this.element).height;
      if (computedStyleHeight && /px$/.test(computedStyleHeight)) {
        return Number(computedStyleHeight.slice(0, -2));
      }

      return this.element.offsetHeight;
    }

    noMoreClamping(lines = this.clamp) {
      return Math.round(this.getElementHeight() / this.lineHeight) <= lines;
    }

    tryCutHalfLine(node) {
      const _data = node.data;
      while (node.data && !this.noMoreClamping(this.clamp - 1)) {
        node.data = node.data.slice(0, -1);
      }

      if (node.data) {
        const lenDiff = _data.length - node.data.length;
        node.data = _data.slice(0, -lenDiff / 2 - 12);
      }
    }

    binarySearchOptimize(node) {
      let previousIterationData = node.data;

      while (!this.noMoreClamping() && node.data) {
        node.data = node.data.slice(0, Math.floor(node.data.length / 2));

        if (this.noMoreClamping()) {
          node.data = previousIterationData;
          return;
        }

        previousIterationData = node.data;
      }
    }

    removeFrom(htmlElement) {
      const childNodes = htmlElement.childNodes;
      const len = childNodes.length;

      if (this.noMoreClamping()) {
        this.clampCallbackBound({ $clamp: 'noclamp' });
        return true;
      }

      for (let i = len - 1; i >= 0; i--) {
        if (this.noMoreClamping()) {
          break;
        }

        this._removeFromChild(htmlElement, childNodes[i]);
      }
    }

    _removeFromChild(parent, node) {
      if (node.nodeType === 3) {
        const _data = node.data;

        // check if after removal of the whole node
        // we still need clamping
        node.data = '';

        if (this.noMoreClamping()) {
          node.data = _data;

          this.binarySearchOptimize(node);

          while (!this.noMoreClamping() && node.data) {
            node.data = node.data.slice(0, -1);
          }

          if (this.noMoreClamping()) {
            this.tryCutHalfLine(node);
          }
        }
      } else if (node.nodeType === 1) {
        node.style.display = 'none';

        // after removing this element we still need to clamp more
        // or the element is not a (wrapping) span
        if (!this.noMoreClamping() || node.tagName !== 'SPAN') {
          parent.removeChild(node);
        } else {
          node.style.display = '';
          this.removeFrom(node);
        }
      }
    }
  }

  return function link($scope, $element, $attrs) {
    const element = $element[0];
    const clamp = Number($attrs.clampHtml);
    const lineHeight = Number($window.getComputedStyle(element).lineHeight.slice(0, -2));
    const clampCallback = $attrs.clampHtmlCallback ? $parse($attrs.clampHtmlCallback) : () => {};
    const clamper = new Clamper(element, clamp, lineHeight, clampCallback.bind($scope));

    const watchExpression = $attrs.clampHtmlData || $attrs.ngBindHtml;
    let previousDataString = null;
    $scope.$watch(watchExpression, (value) => {
      if (String(value) === previousDataString) {
        return;
      }

      previousDataString = String(value);

      $scope.$evalAsync(() => {
        if ($element[0].querySelector('.see-more')) {
          // already clamped
          return;
        }

        const originalHtml = $element.html();
        const nothingToDo = clamper.removeFrom(element);

        if (nothingToDo) {
          clampCallback($scope, { $clamp: 'noclamp' });
          return;
        }

        clampCallback($scope, { $clamp: 'clamp' });
        const seeMore = angular.element('<span>... <a class="see-more">See more</a></span>');
        $element.append(seeMore);

        seeMore.on('click', () => {
          $scope.$apply(() => {
            $element.html(originalHtml);
            clampCallback($scope, { $clamp: 'unclamp' });
          });
        });
      });
    });
  };
}
